import { useCallback } from 'react';

import { usePerformanceActions } from 'src/store';
import { useCipEvents } from 'src/services';
import { AD_ACCOUNTS_SELECTION_POPUP } from '../types';
import { usePopups } from '../services';

export const useAdAccountsSelectionPopup = () => {
  const popups = usePopups();
  const performanceActions = usePerformanceActions();
  const cipEvents = useCipEvents();

  return useCallback(
    (channel) => {
      return new Promise((resolve) => {
        popups.openPopup(AD_ACCOUNTS_SELECTION_POPUP, {
          channel,
          onClose: async () => {
            resolve();
            popups.closePopup(AD_ACCOUNTS_SELECTION_POPUP);
          },
          onSubmit: ({ channel, selectedAccountIds }) => {
            cipEvents.trackConnectAdAccounts(channel, selectedAccountIds);
            if (selectedAccountIds.length) {
              performanceActions.extractTextVariations({
                channel,
                selectedAccountIds,
              });
            } else {
              performanceActions.cancelWaitRequests(channel);
              performanceActions.updateConnectedAccounts({ channel, selectedAccountIds });
            }
            resolve({ channel, selectedAccountIds });
            popups.closePopup(AD_ACCOUNTS_SELECTION_POPUP);
          },
        });
      });
    },
    [performanceActions, cipEvents, popups]
  );
};
